<template>
  <span>
    {{ localisation }}
  </span>
</template>

<script>
export default {
  props: {
    config: Object
  },
  computed: {
    localisation() {
      let lat = this.config?.rcPlus?.status?.latitude != undefined ?
        this.config.rcPlus.status.latitude :
        ENV.NO_DATA;

      let lon = this.config?.rcPlus?.status?.longitude != undefined ?
        this.config.rcPlus.status.longitude :
        ENV.NO_DATA;

      let height = this.config?.rcPlus?.status?.height != undefined ?
        this.config.rcPlus.status.height :
        ENV.NO_DATA;

      return this.$e("Longitude") + " : " + lon + " / " + this.$e("Latitude") + " : " + lat + " / " + this.$e("Hauteur") + " : " + height;
    },
  },
};
</script>
